<template>
  <div>
    <el-form
      autocomplete="off"
      ref="form" :rules="rules" :model="form"
      @submit.prevent.native="submit">
      <el-form-item prop="email" :label="$t('adminSignInPage.emailLabel')">
        <el-input
          v-model="form.email"
          data-test="email-input"
          :placeholder="$t('adminSignInPage.emailLabel')">
        </el-input>
      </el-form-item>
      <el-form-item prop="password" :label="$t('adminSignInPage.passwordLabel')">
        <el-input
          type="password"
          autocomplete="new-password"
          v-model="form.password"
          data-test="password-input"
          :placeholder="$t('adminSignInPage.passwordLabel')">
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          v-loading="loading"
          data-test="submit-button"
          type="success" style="width: 100%;"
          @click="submit">
          {{ $t('adminSignInPage.submitButtonText') }}
        </el-button>
      </el-form-item>

    </el-form>
  </div>
</template>
<script>
import _ from 'lodash';

export default {
  data() {
    return {
      loading: false,
      rules: {
        email: [
          {
            required: true,
            message: this.$t('adminSignInPage.validEmailRequiredMessage'),
            trigger: 'blur',
          },
          {
            type: 'email',
            message: this.$t('adminSignInPage.validEmailRequiredMessage'),
            trigger: ['blur', 'change'],
          },
        ],
        password: [
          {
            required: true,
            message: this.$t('adminSignInPage.validPasswordRequiredMessage'),
            trigger: 'blur',
          },
        ],
      },
      form: {
        email: '',
      },
    };
  },
  methods: {
    async login(email, password) {
      try {
        this.loading = true;
        await this.$store.dispatch('auth/loginWithCredentials', { email, password });
        this.showSuccessMessage();
        this.$router.push({ name: 'Dashboard' });
      } catch (e) {
        const code = _.get(e, 'response.data.code');
        if (code) {
          this.$message.error({ message: this.$t(`commons.${code}`) });
        } else {
          this.showDefaultErrorMessage();
        }
      }
      this.loading = false;
    },
    showSuccessMessage() {
      this.$message.success({ message: this.$t('adminSignInPage.successMessage') });
    },
    showDefaultErrorMessage() {
      this.$message.error({ message: this.$t('commons.defaultErrorMessage') });
    },
    submit(e) {
      console.log('PREVENT');
      e.preventDefault();
      this.$refs.form.validate((valid) => {
        if (!valid) { return; }
        this.login(this.form.email, this.form.password);
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
</style>
